import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { BonusSettlementCustomerDetail } from '../models/bonus-settlement-customer-detail';
import { BonusSettlementCustomerDetailsSidebar } from '../models/bonus-settlement-customer-details-sidebar';

export class BonusSettlementsCustomerDetailApi {
    constructor(protected baseUrl: string) {}

    public getBonusSettlementCustomerDetailSidebar(
        id: number,
        customerId: number
    ): Promise<ApiResult<BonusSettlementCustomerDetailsSidebar>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/bonus-settlements/${id}/customers/${customerId}/details`),
            response => response.data
        );
    }

    public getBonusSettlementCustomerDetails(
        id: number,
        customerId: number,
        searchParams?: URLSearchParams
    ): Promise<ApiResult<PaginatedResponse<BonusSettlementCustomerDetail>>> {
        return safeRequest(
            () =>
                request.get(`${this.baseUrl}/bonus-settlements/${id}/customers/${customerId}/suppliers`, {
                    params: searchParams,
                }),
            response => response.data
        );
    }
}
